import Vue from "vue";
import {MutationTree} from "vuex";
import { MessagesState } from "@/types/store/clientzone";

export const mutations: MutationTree<MessagesState> = {
    SET_VENUE: (state, payload) => Vue.set(state, "selectedVenue", payload),
    SET_MESSAGES: (state, payload) => Vue.set(state, "messages", payload),
    SET_ERROR_MESSAGES: (state, payload) => Vue.set(state, "errorMessage", payload),
}
